import addWindowScrollPositionToDocument from './modules/viewport';
import * as lottie from './modules/lottie';
import initShowText from './modules/showText';

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
    console.error(e);
}

$(document).ready(() => {

    $('#smartwizard').smartWizard({
        justified: false, // Nav menu justification. true/false
        autoAdjustHeight: false, // Automatically adjust content height
        cycleSteps: false, // Allows to cycle the navigation of steps
        backButtonSupport: true, // Enable the back button support
        enableURLhash: true, // Enable selection of the step based on url hash
        toolbarSettings: {
            toolbarPosition: 'none', // none, top, bottom, both
        },
        anchorSettings: {
            removeDoneStepOnNavigateBack: true,
        },
        keyboardSettings: {
            keyNavigation: false,
        },
        disabledSteps: [], // Array Steps disabled
        errorSteps: [], // Highlight step with errors
        hiddenSteps: [], // Hidden steps
    });
});

lottie.initLottie();
initShowText();
addWindowScrollPositionToDocument();
